<main *ngIf="show" class="main__spinner">
    <div class="spinner__imagem">
        <img  class="rotate-image" [src]="imgLogo" alt="Carregando dados"/>
    </div>
    <p class="spinner__texto">Carregando
        <span class="loading-dots">...</span>
    </p>
</main>